import { useTranslation } from 'react-i18next';
import { MockPill } from '@components/ui/MockPill/MockPill';
import { SparklesIcon } from '@utils/icons';
import styles from './SmartSearchPlaceholder.module.css';

/**
 * Visual-only mockup of the planned AI-assisted analytics search.
 * The input accepts text but submits nowhere; the example chips are
 * static. When the backend AI agent endpoint is wired, this component
 * gets a real `onSubmit` and the chips become click-to-prefill.
 */
export function SmartSearchPlaceholder() {
  const { t } = useTranslation();
  const examples = t('analytics.smartSearch.examples', {
    returnObjects: true,
  }) as string[];

  return (
    <section
      className={styles.panel}
      aria-label={t('analytics.smartSearch.title')}
    >
      <header className={styles.header}>
        <span className={styles.iconWrap} aria-hidden="true">
          <SparklesIcon size={24} />
        </span>
        <div className={styles.titleBlock}>
          <h2 className={styles.title}>
            {t('analytics.smartSearch.title')}
            <MockPill kind="badge" />
          </h2>
          <p className={styles.subtitle}>
            {t('analytics.smartSearch.subtitle')}
          </p>
        </div>
      </header>

      <div className={styles.searchField}>
        <span className={styles.searchIcon} aria-hidden="true">
          <SearchIcon />
        </span>
        <input
          type="text"
          className={styles.input}
          placeholder={t('analytics.smartSearch.placeholder')}
          aria-label={t('analytics.smartSearch.title')}
        />
      </div>

      <ul className={styles.chips}>
        {examples.map((example) => (
          <li key={example}>
            <button type="button" className={styles.chip}>
              {example}
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}

function SearchIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      aria-hidden="true"
    >
      <circle cx="7" cy="7" r="5" />
      <line x1="10.7" y1="10.7" x2="14" y2="14" strokeLinecap="round" />
    </svg>
  );
}
